import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import ErrorBoundary from '../../../ErrorBoundary';
import { Input } from 'reactstrap';

const StatusCellRender = ({
  rowData,
  updateRowValue,
  hasTouched = false,
  required = false,
  listArray,
  col,
  drugexclusion,
  errstatus
}) => {
  const API = useAxios();
  const subProps = {};
  //const { patientStatus } = rowData;
  const { dataField } = col
  const [statusList, setStatusList] = useState(listArray);
  // const [claimId, setClaimId] = useState(patientStatus);
  const [claimId, setClaimId] = useState(rowData[dataField]);
  useEffect(() => {
    setClaimId(rowData[dataField]);
  }, [rowData, dataField]);
  
  const fetchData = async () => {
    try {
      const { data } = await API.get(
        'RCMConfig/TypeStatus/AllowedClaimStatus/' + rowData.claimStatusID,
        {
          hasDefaultURL: true,
        }
      );
      setStatusList(data);
      if (data.length === 1) {
        const { id } = data[0];
        setClaimId(id);
        updateRowValue(id, dataField);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    // fetchData();
  }, []);

  const handleChange = (event) => {
    const { value } = event.target;
    setClaimId(value);
    updateRowValue(value, dataField);
  };

  if (required && hasTouched) {
    subProps.title = 'Status is required';
  }

 // const disabled = statusList.length === 1;

  return (
    <div>
      <ErrorBoundary>
        <Input
          type='select'
          // onChange={(e) => handleChange(e)}
          onChange={handleChange}
          bsSize='sm'
          className={`d-inline-block ${required ? 'required' : ''}`}
          value={claimId || ''}
          {...subProps}
          disabled={statusList.length === 1}
        >
          {/* <option value={''}>--Select--</option> */}
          {statusList.length > 1 && <option value=''>--Select--</option>}
          {statusList.map((status) => (
            <>
            {/* {drugexclusion==true?<option key={status.id} value={status.label}> {status.label} </option>
:             
<option key={status.id} value={status.id}> {status.label} </option>
 } */}
 <option key={status.id} value={status.id}> {status.label} </option>

            </>
           //const { id, label } = status;
           // return (
              // <option key={id} value={id}>
              //   {label}
              // </option>
            //);
          ))}
        </Input>
        {errstatus && <div className="text-danger">Status is Required</div>}
      </ErrorBoundary>
    </div>
  );
};

export default StatusCellRender;
